import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-loading-spinner',
  standalone: true,
  imports: [],
  template: ` <div class="spinner-container">
    @if ('border' === type) {
      <div class="spinner-border" role="status">
        <span class="sr-only"></span>
      </div>
    } @else if ('grow' === type) {
      <div class="spinner-grow text-warning" role="status">
        <span class="sr-only"></span>
      </div>
    }
  </div>`,
  styleUrl: './loading-spinner.component.scss',
})
export class LoadingSpinnerComponent {
  @Input() type: 'grow' | 'border' = 'border';
}
